export default function CaRelationshipsAndFamily() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.9918 3.63471C10.5926 0.751309 6.5917 -0.0243169 3.58563 2.61601C0.579573 5.25634 0.156361 9.67084 2.51704 12.7936C4.47978 15.3899 10.4197 20.8658 12.3665 22.6381C12.5843 22.8364 12.6932 22.9355 12.8203 22.9745C12.9311 23.0085 13.0524 23.0085 13.1633 22.9745C13.2903 22.9355 13.3992 22.8364 13.617 22.6381C15.5638 20.8658 21.5038 15.3899 23.4665 12.7936C25.8272 9.67084 25.4557 5.22857 22.3979 2.61601C19.3402 0.00345679 15.391 0.751309 12.9918 3.63471Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
